import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, loadData, toFormData } from 'src/app/shared/utils/helpers';

import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ShipToDistribuidor } from 'src/app/shared/models/shipToDistribuidor';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { Direccion } from 'src/app/shared/models/direccion';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { DataClientePedidos } from 'src/app/shared/models/dataClientePedidos';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';


@Component({
  selector: 'app-shipto-distribuidores-dialog',
  templateUrl: './shipto-distribuidores-dialog.component.html'
})
export class ShipToDistribuidoresDialogComponent implements OnInit {
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  shipToDistribuidores: ShipToDistribuidor[] = [];

  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  d: ShipToDistribuidor;
  codigoDEdit: number = -1;

  dirEntregas: Direccion[] = [];
  dirEntregaSeleccionada: Direccion;
  direcciones: Direccion[] = [];
  direccionSeleccionada: Direccion;


  cuentasDistribuidores: CuentaDistribuidor[] = [];
  ctaDistrubuidorSeleccionada: CuentaDistribuidor;


  //#region autocomplete Cliente

  clientesEncontrados: any;
  clienteSeleccionado: Cuenta;
  fcAutocompleteCliente = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCliente = false;
  minLengthTermCliente = 2;

  //#endregion

  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ShipToDistribuidoresDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      autor: [''],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      idSalesOrg: [''],
      idPais: [''],
      nroCliente: ['', Validators.required],
      nombreCliente: [''],
      nroClienteShipTo: [''],
      shipTo: ['', Validators.required],
      nroClienteDistribuidor: ['', Validators.required],
      nombreDistribuidor: [''],
      sucDistribuidor: ['', Validators.required],
      sucursal: [''],
      displayValue: [''],

      shipToData: [new Cuenta()],
      sucDistribuidorData: [new Cuenta()],

      codigo: [0],

    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.d != null) {
      this.codigoDEdit = data.d.codigo
      this.d = data.d

    }
  }
  public Etiquetas: {

    Habilitacion: string
    Codigo: string
    IdCompania: string
    IdSalesOrg: string

    Cliente: string
    NroCliente: string
    NombreCliente: string
    DireccionEntrega: string
    CuentaDistribuidor: string
    Direccion: string
    NroClienteDireccionEntrega: string

  }

  public Validaciones: {
    Compania: string
    SalesOrg: string
    Codigo: string

    NroClienteDistribuidor: string
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {
      Habilitacion: this.configService.etiquetas.Habilitacion,
      Codigo: this.configService.etiquetas.Codigo,
      IdCompania: this.configService.etiquetas.Compania,
      IdSalesOrg: this.configService.etiquetas.SalesOrg,

      Cliente: this.configService.etiquetas.Cliente,
      NroCliente: this.configService.etiquetas.NroCliente,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega,
      CuentaDistribuidor: this.configService.etiquetas.CuentaDistribuidor,
      Direccion: this.configService.etiquetas.Direccion,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,


    }

    this.Validaciones = {

      Codigo: this.configService.validaciones.Codigo,
      Compania: this.configService.validaciones.Compania,
      SalesOrg: this.configService.validaciones.SalesOrg,
      NroClienteDistribuidor: this.configService.validaciones.NroClienteDistribuidor,

    }

    this.fcAutocompleteCliente.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCliente
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.clientesEncontrados = [];
          this.loadingFcAutocompleteCliente = true;
        }),
        switchMap(value => this.admService.cClientesPedidoAutocompleteSearch(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.idDivision, this.loggedService.logged.idZonaVendedor, this.loggedService.logged.idRegion, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteCliente = false
            }),
          )
        )
      )
      .subscribe((data: Cuenta[]) => {
        this.clientesEncontrados = data;

      });


    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.tablasService.cShipToDistribuidorDB(this.codigoDEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], ShipToDistribuidor]) => {

      if (data[0].length) {
        this.companias = data[0];
      }

      if (data[1].length) {
        this.salesOrgs = data[1];
      }

      if (this.idTipo == 1) {
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }

      }

      if (typeof this.d != 'undefined') {
        if (this.codigoDEdit != -1) {
          if (data[2] != null) {

            loadData(this.form, data[2])

            this.form.controls['nroClienteDistribuidor'].setValue(data[2].nroCliente);

            this.admService
              .cDataCliente(data[2].idPais, data[2].idCompania, data[2].idSalesOrg, data[2].nroClienteShipTo)
              .subscribe((data: DataClientePedidos) => {

                if (data != null) {


                  this.dirEntregas = data.direccionesEntregas != null ? data.direccionesEntregas : []

                }
              })
            this.admService
              .cDireccionesDistribuidorCliente(data[2].idPais, data[2].idCompania, data[2].idSalesOrg, data[2].nroCliente)
              .subscribe((data: Direccion[]) => {

                if (data != null) {
                  this.direcciones = data;
                  if (!this.direcciones.length) {
                    this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.DistribuidorSinSucursales, 2, 2);
                  }

                }

              })
            console.log(this.form)
            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }

    });
  }
  compareCompanias(compLista: any, compD: any): boolean {
    if (typeof compLista != 'undefined' && typeof compD != 'undefined') {

      return compLista === compD;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgD: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrgD != 'undefined') {

      return salesOrgLista === salesOrgD;
    }
  }

  guardarShipToDistribuidor() {
    const formValue = this.form.value;
    const modeloConvertido: ShipToDistribuidor = {
      idPais: formValue.idPais,
      idCompania: formValue.idCompania,
      idSalesOrg: formValue.idSalesOrg,
      shipTo: formValue.shipTo,
      sucDistribuidor: formValue.sucDistribuidor,
      nroCliente: formValue.nroCliente,
      shipToData: formValue.shipToData,
      sucDistribuidorData: formValue.sucDistribuidorData,
      autor: formValue.autor,
      habilitacion: formValue.habilitacion,
      codigo: formValue.codigo,
      displayValue: '',
      fechaCreacion: formValue.fechaCreacion,
      nroClienteShipTo: formValue.nroClienteShipTo
    };
    switch (this.idTipo) {
      case 1:
        // this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        modeloConvertido.autor = this.loggedService.logged.userName;
        this.tablasService.aShipToDistribuidor(modeloConvertido).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.tablasService
          .mShipToDistribuidor(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }

  getOptionTextCliente(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputCliente(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermCliente) {
      this.clientesEncontrados = [];
      this.clienteSeleccionado = null;

    }
  }

  seleccionarCliente(c: any) {

    if (c != "-1") {

      this.clienteSeleccionado = c; //El autocomplete trae el objeto para asignar a la variable. El autocomplete NO esta enlazado con esta variable


      this.admService
        .cDataCliente(this.clienteSeleccionado.idPais, this.clienteSeleccionado.idCompania, this.clienteSeleccionado.idSalesOrg, this.clienteSeleccionado.nroCliente)
        .subscribe((data: DataClientePedidos) => {
          this.form.controls['nroCliente'].setValue(this.clienteSeleccionado.nroCliente);
          this.form.controls['nombreCliente'].setValue(this.clienteSeleccionado.nombre);

          if (data != null) {


            this.dirEntregas = data.direccionesEntregas != null ? data.direccionesEntregas : []

            this.cuentasDistribuidores = data.cuentasDistribuidores != null ? data.cuentasDistribuidores : [];
            this.direcciones = data.direcciones != null ? data.direcciones : [];

          }
          else {
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
          }

        }

        )

    }
    else {

      this.form.controls['nroCliente'].reset();
      this.form.controls['nombreCliente'].reset();

      this.clienteSeleccionado = null;
    }

  }

  limpiarCliente(resetFormControl: boolean) {
    this.clientesEncontrados = [];
    this.seleccionarDirEntrega(null);

    this.seleccionarCuentaDistribuidor(null);
    this.seleccionarCliente("-1");
    this.cuentasDistribuidores = [];
    this.seleccionarCliente("-1");

    if (resetFormControl) {
      this.fcAutocompleteCliente.setValue('');

    }
    this.form.markAsUntouched();
    this.form.markAsPristine();

  }

  seleccionarDireccion(d: any) { //Sucursal

    this.direccionSeleccionada = null;
    if (d != null) {
      this.direccionSeleccionada = this.direcciones.find(c => c.nroCliente == this.form.controls['sucDistribuidor'].value);
      if (this.direccionSeleccionada != null) {
        this.form.controls['sucursal'].setValue(this.direccionSeleccionada.ciudad + " - " + this.direccionSeleccionada.calleNro);
      }
    }
    else {
      this.form.controls['sucursal'].reset();
    }

  }

  seleccionarDirEntrega(de: any) {

    this.seleccionarDireccion(null);

    this.dirEntregaSeleccionada = null;
    if (de != null) {
      this.dirEntregaSeleccionada = this.dirEntregas.find(c => c.nroCliente == this.form.controls['shipTo'].value);
      if (this.dirEntregaSeleccionada != null) {

        this.form.controls['shipTo'].setValue(this.dirEntregaSeleccionada.nroCliente);

      }
    } else {

      this.form.controls['shipTo'].reset();
    }

  }

  seleccionarCuentaDistribuidor(d: any) {
    this.seleccionarDireccion(null);

    if (d != null) {
      this.ctaDistrubuidorSeleccionada = this.cuentasDistribuidores.find(c => c.nroClienteCuenta == d);
      if (this.ctaDistrubuidorSeleccionada != null) {
        this.form.controls['nombreDistribuidor'].setValue(this.ctaDistrubuidorSeleccionada.nombre);
        this.admService
          .cDireccionesDistribuidorCliente(this.clienteSeleccionado.idPais, this.clienteSeleccionado.idCompania, this.clienteSeleccionado.idSalesOrg, this.ctaDistrubuidorSeleccionada.nroClienteCuenta)
          .subscribe((data: Direccion[]) => {

            if (data != null) {
              this.direcciones = data;
              if (!this.direcciones.length) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.DistribuidorSinSucursales, 2, 2);
              }

            }

          })
      }

    }
    else {
      this.direcciones = [];
      this.form.controls['sucDistribuidor'].reset();
      this.form.controls['nombreDistribuidor'].reset();
    }
  }
  compareDireccionEntrega(deLista: any, de: any): boolean {
    return deLista === de;
  }
  compareCuentasDistribuidores(dLista: any, d: any): boolean {
    return dLista == d;
  }
  compareDirecciones(dLista: any, dPV: any): boolean {
    return dLista == dPV;
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
